export default function stripHtml(html) {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/stripHtml', stripHtml);